export default "__VITE_ASSET__8df82d01__"